<template>
  <div>
    <section  id="home" class="parallax h-screen w-full">
      <img src="../assets/banner2.jpg" id="bg">
      <div id="text" class="text-center w-full z-50 text-white">
        <h3 class="about text-3xl md:text-6xl"><span class="border-t-2 border-pink-600 pt-1">APTITUDE</span> TO THE <span class="main-color italic border-b-2  pb-1">NEXT LEVEL</span></h3>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'UserHome',
  mounted(){
    window.addEventListener('scroll', this.scrollFunc)
  },
  data(){
    return{
      scrollPos: '',
    }
  },
    methods:{
    scrollFunc() {
      let bg = document.getElementById("bg")
      let text = document.getElementById("text")
      if(bg && text) {
        text.style.position = "relative";
  
        const val = window.scrollY
        this.scrollPos = val;
  
        bg.style.top = val * 0.5 + 'px'
        text.style.top = -val * 0.15 + 'px'
      }
    }
  },

}
</script>


<style lang="stylus">
.parallax
  position relative
  overflow hidden
  display flex
  justify-content center
  align-items center

.parallax:before
  content ''
  position absolute 
  bottom 0
  width 100%
  height 100px
  // background linear-gradient(to top, #fff, transparent  )
  z-index 5000

.parallax:after
  content ''
  position absolute 
  top 0
  left 0
  width 100%
  height 100%
  // background #fff
  z-index 5000
  mix-mix-blend-mode color 

.parallax > img
  position absolute
  top 0
  left 0 
  width 100%
  height 100%
  object-fit cover
  pointer-events none

.about{
  font-family: 'Oswald', sans-serif;
}

.price{
  font-family: 'Assistant', sans-serif;
}

.h-120{
  min-height: 550px;
}

.h-122{
  // height: 625px;
}

</style>
